import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface SectionHeaderProps {
  title: string;
  linkText?: string;
  linkTo?: string;
  className?: string;
}

export function SectionHeader({ title, linkText, linkTo, className }: SectionHeaderProps) {
  return (
    <div className={cn('flex items-center justify-between', className)}>
      <h2 className="text-lg font-semibold text-ink font-heading">{title}</h2>
      {linkText !== undefined && linkTo !== undefined && (
        <Link to={linkTo} className="text-sm text-brand-dark hover:underline font-medium">
          {linkText}
        </Link>
      )}
    </div>
  );
}
